class sliderPager {

	constructor(sliderId) {
	}

	getSlidePager(sliderId) {

		return (
			`
			<div class="slide-pager">
				<div class="slide-pager__inner">
					<div class="slide-pager__half slide-pager__half--left">
						<div id="clickable" class="slick-prev slick-arrow" data-slider-id="${sliderId}" data-direction="-1">
							<div id="clickable" class="arrow-icon arrow-icon--prev">
							</div>
						</div>
						<span class="slide-pager__number slide-pager__number--index">1</span>
					</div>
					<div class="slide-pager__half slide-pager__half--right">
						<span class="slide-pager__number slide-pager__number--total"></span>
						<div id="clickable" class="hoverable slick-next slick-arrow" data-slider-id="${sliderId}" data-direction="1" data>
							<div id="clickable" class="arrow-icon arrow-icon--next">

								<svg class="progress">
									<circle class="progress__circle" cx="50" cy="50" r="46"></circle>
								</svg>

							</div>
						</div>
					</div>
				</div>
			</div>`
		)

	}

}
module.exports = new sliderPager;